export default {"src":"/_next/static/media/caretdown.4f25cc88.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};